module.exports = __webpack_public_path__ + "static/media/get_more_img_3.1e644fe6.svg";